var map = {
	"./bonus-dice-1-x.png": 631,
	"./bonus-dice-2-x.png": 632,
	"./bonus-dice-3-x.png": 633,
	"./bonus-dice-4-x.png": 634,
	"./bonus-dice-5-x.png": 635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 630;